<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelItemRequisition popup="popup" [model]="contenuMenuContextuelItemRequisition"></p-menu>
<p-menu #menuContextuelAjustementHeureKm popup="popup" [model]="contenuMenuContextuelAjustementHeureKm"></p-menu>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div class="flex align-items-center gap-4 mb-4">
                <div class="w-6rem h-6rem bg-gray-100 border-round flex align-items-center justify-content-center">
                    <i *ngIf="requisition.type.typeRequisitionId === 1" class="pi pi-truck text-4xl"></i>
                    <i *ngIf="requisition.type.typeRequisitionId === 2" class="pi pi-undo text-4xl"></i>
                    <i *ngIf="requisition.type.typeRequisitionId === 3" class="pi pi-arrows-h text-4xl"></i>
                </div>
                <div>
                    <div class="flex align-items-center gap-3 mb-1">
                        <h5 class="m-0">{{requisition.type.nom}}</h5>
                        <span [class]="'statut ' + requisition.statut.nom.toLowerCase()">
                            {{requisition.statut.nom}}
                        </span>
                    </div>
					<div class="flex align-items-center gap-1 mb-1">
						<span class="text-lg">{{requisition.numero}}</span>
						<app-bouton-favori [titrePage]="titrePagePrincipale" [type]="eTypeFavori"></app-bouton-favori>
					</div>
					<span *ngIf="modeApercu">
						<i class="pi pi-id-card ml-4"></i>
						<a class="lienFicheComplete" (click)="ouvrirFicheComplete()">Aller à la fiche complète</a>
					</span>
                </div>
            </div>

			<p-menubar autoDisplay="false" [model]="menu" *ngIf="!modeApercu">
				<p-button *ngIf="estAutorise('requisition_modifier') && modeConsultation() && estModifiable"
					(click)="btnModifier_click()" icon="pi pi-pencil" styleClass="p-button-primary"></p-button>
				<p-button *ngIf="modeAjoutModification()" (onClick)="enregistrerModifications()" label
					icon="pi pi-check" styleClass="p-button-success mr-2">
				</p-button>
				<p-button *ngIf="modeAjoutModification()" (onClick)="annulerModification($event)" icon="pi pi-times"
					styleClass="p-button-secondary"></p-button>
			</p-menubar>

		</p-card>
	</div>


</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<p-tabView [scrollable]="true" #tabView [(activeIndex)]="tabIndex" orientation="left"
				(onChange)="surChangementOnglet($event)">
				<p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
					<div class="formgrid grid gap-3">
						<!-- Informations de base -->
						<div class="col-12">
							<div class="surface-50 border-round p-3 mb-3">
								<div class="flex align-items-center gap-2 mb-2">
									<i class="pi pi-info-circle text-primary"></i>
									<span class="font-semibold text-900">Informations de base</span>
								</div>
								<div class="formgrid grid">
									<div class="field col-12 md:col-4 mb-2">
										<label for="numero" class="text-700 font-medium">Numéro</label>
										<input id="numero" type="text" pInputText readonly value="{{requisition.numero}}" class="w-full">
									</div>
									<div class="field col-12 md:col-4 mb-2">
										<label for="date" class="text-700 font-medium">Date</label>
										<input *ngIf="modeConsultation()" id="date" type="text" pInputText readonly
											value="{{requisition.date | date:'yyyy-MM-dd'}}" class="w-full">
										<p-calendar *ngIf="!modeConsultation()" id="date" appendTo="body" showIcon=true
											[(ngModel)]="requisition.date" dateFormat="yy-mm-dd" [yearNavigator]="true"
											[monthNavigator]="true" yearRange="2000:2040" class="w-full"></p-calendar>
									</div>
									<div class="field col-12 md:col-4 mb-2">
										<label for="demandeur" class="text-700 font-medium">Demandeur</label>
										<span *ngIf="modeConsultation()" class="flex align-items-center h-full"><app-employe-avec-emplacement [employe]="requisition.demandeur"></app-employe-avec-emplacement></span>
										<p-dropdown *ngIf="!modeConsultation()" id="demandeur" #champDemandeur [options]="listeEmployes"
											[(ngModel)]="requisition.demandeur" optionLabel="nom" [showClear]="true" filter="true"
											filterBy="prenom,nom" appendTo="body" placeholder="Sélectionner un demandeur..." class="w-full">
											<ng-template pTemplate="selectedItem">
												<div *ngIf="requisition.demandeur">
													<div>{{requisition.demandeur.prenom}} {{requisition.demandeur.nom}}</div>
												</div>
											</ng-template>
											<ng-template let-employe pTemplate="item">
												<div>
													<div>{{employe.prenom}} {{employe.nom}}</div>
												</div>
											</ng-template>
										</p-dropdown>
										<small class="p-error" *ngIf="submitted && !requisition.demandeur">Le demandeur est obligatoire.</small>
									</div>
								</div>
							</div>
						</div>

						<!-- Localisation -->
						<div class="col-12">
							<div class="surface-50 border-round p-3 mb-3">
								<div class="flex align-items-center gap-2 mb-2">
									<i class="pi pi-map-marker text-primary"></i>
									<span class="font-semibold text-900">Localisation</span>
								</div>
								<div class="formgrid grid">
									<div class="field col-12 md:col-6 mb-2">
										<label for="de" class="text-700 font-medium">De</label>
										<div id="de" class="flex align-items-center gap-2 w-full p-2 surface-100 border-round">
											<i class="pi pi-map-marker text-primary"></i>
											<span>{{requisition.de.nom}}</span>
											<span class="font-bold">({{requisition.de.code}})</span>
										</div>
									</div>
									<div class="field col-12 md:col-6 mb-2">
										<label for="a" class="text-700 font-medium">À</label>
										<div id="a" class="flex align-items-center gap-2 w-full p-2 surface-100 border-round">
											<i class="pi pi-map-marker text-primary"></i>
											<span>{{requisition.a.nom}}</span>
											<span class="font-bold">({{requisition.a.code}})</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Transport -->
						<div class="col-12">
							<div class="surface-50 border-round p-3 mb-3">
								<div class="flex align-items-center gap-2 mb-2">
									<i class="pi pi-truck text-primary"></i>
									<span class="font-semibold text-900">Transport</span>
								</div>
								<div class="formgrid grid">
									<div class="field col-12 md:col-4 mb-2">
										<label for="camion" class="text-700 font-medium">Camion</label>
										<input id="camion" type="text" pInputText [readonly]="modeConsultation()"
											[(ngModel)]="requisition.camion" class="w-full">
									</div>
									<div class="field col-12 md:col-4 mb-2">
										<label for="remorque" class="text-700 font-medium">Remorque</label>
										<input id="remorque" type="text" pInputText [readonly]="modeConsultation()"
											[(ngModel)]="requisition.remorque" class="w-full">
									</div>
									<div class="field col-12 md:col-4 mb-2">
										<label for="chauffeur" class="text-700 font-medium">Chauffeur</label>
										<input id="chauffeur" type="text" pInputText [readonly]="modeConsultation()"
											[(ngModel)]="requisition.chauffeur" class="w-full">
									</div>
								</div>
							</div>
						</div>

						<!-- Notes -->
						<div class="col-12">
							<div class="surface-50 border-round p-3">
								<div class="flex align-items-center gap-2 mb-2">
									<i class="pi pi-comment text-primary"></i>
									<span class="font-semibold text-900">Notes</span>
									<i *ngIf="estAutorise('requisition_modifier') && modeConsultation()"
										class="pi pi-pencil text-primary cursor-pointer ml-auto" 
										style="font-size: 0.875rem" 
										(click)="modifierNote($event)"> Modifier la note</i>
								</div>
								<span *ngIf="modeConsultation()" class="formatted-text champConsultation block w-full" style="white-space: pre-wrap;">{{requisition.note}}</span>
								<textarea *ngIf="!modeConsultation()" id="note" [rows]="2" pInputTextarea autoResize="autoResize"
									[(ngModel)]="requisition.note"
									class="w-full" placeholder="Ajouter une note..."></textarea>
							</div>
						</div>
					</div>

					<div class="flex flex-column my-2">
						<h5 class="my-1">Items du transport</h5>
						<span class="text-500">Items ajoutés manuellement ou importés d'une commande</span>
					</div>
					<div class="flex gap-2 mb-2">
						<span class="p-input-icon-left">
							<i class="pi pi-search"></i>
							<input pInputText type="text"
								(input)="dt.filterGlobal($event.target.value, 'contains')"
								placeholder="Recherche..." />
						</span>
						<button
							*ngIf="estModifiable && !modeApercu && estTypeRequisition() && estAutorise('requisition_modifier')"
							pButton pRipple icon="pi pi-plus"
							class="p-button-success"
							(click)="surAjoutItem()"></button>
					</div>

					<p-table #dt [value]="requisition.itemsRequisition" [columns]="selectedColumns"
						dataKey="itemRequisitionId" tableStyleClass="tableNormale"
						[(selection)]="selectionMultipleItemRequisition" (onRowSelect)="surChangementSelection()"
						(onRowUnselect)="surChangementSelection()" (onHeaderCheckboxToggle)="surChangementSelection()"
						autoLayout="true" styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true"
						[filterDelay]="0" [globalFilterFields]="['item.numero','item.description','demandeur']">
						<ng-template pTemplate="header" let-columns>
							<tr>

								<th *ngIf="estAutorise('requisition_modifier')" style="min-width: 3rem">
									<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
								</th>
								<th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Qte
										<p-sortIcon field="quantiteDemande"></p-sortIcon>
										<p-columnFilter type="text" field="quantiteDemande" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>

								<th pSortableColumn="item.categorie.nom">
									<div class="flex justify-content-between align-items-center">
										Catégorie
										<p-sortIcon field="item.categorie.nom"></p-sortIcon>
										<p-columnFilter type="text" field="item.numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="item.numero">
									<div class="flex justify-content-between align-items-center">
										Numéro
										<p-sortIcon field="item.numero"></p-sortIcon>
										<p-columnFilter type="text" field="item.numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="item.description">
									<div class="flex justify-content-between align-items-center">
										Description
										<p-sortIcon field="item.description"></p-sortIcon>
										<p-columnFilter type="text" field="item.description" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<!-- <th pSortableColumn="item.quantite">
									<div class="flex justify-content-between align-items-center">
										Inv.
										<p-sortIcon field="item.quantite"></p-sortIcon>
										<p-columnFilter type="number" field="item.quantite" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th> -->
								<th pSortableColumn="demandeur.prenom">
									<div class="flex justify-content-between align-items-center">
										Demandeur
										<p-sortIcon field="demandeur.prenom"></p-sortIcon>
										<p-columnFilter type="text" field="demandeur.prenom" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="expediteur">
									<div class="flex justify-content-between align-items-center">
										Expéditeur
										<p-sortIcon field="expediteur"></p-sortIcon>
										<p-columnFilter type="text" field="expediteur" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<!-- <th pSortableColumn="unite.numero">
									<div class="flex justify-content-between align-items-center">
										Unité
										<p-sortIcon field="unite.numero"></p-sortIcon>
										<p-columnFilter type="text" field="unite.numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th> -->
								<th></th>
								<th *ngIf="!modeApercu" style="min-width: 7rem; width: 7rem;"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item>

							<tr>
								<td *ngIf="estAutorise('requisition_modifier')">
									<p-tableCheckbox [value]="item"></p-tableCheckbox>
								</td>
								<td>{{item.quantite}}</td>
								<td>{{item.item.categorie.nom}}</td>
								<td>{{item.item.numero}}</td>
								<td>{{item.item.description}}</td>
								<td><app-employe-avec-emplacement [employe]="item.demandeur"></app-employe-avec-emplacement></td>
								<td>{{item.expediteur}}</td>
								<!-- <td>{{item.unite?.numero}}</td> -->
								<td>
									<p-messages *ngIf="displayMessage(item) && !modeApercu && requisition.statut.statutId != 2" severity="warn" [closable]="false">
										<ng-template pTemplate>
											<p>
												<span class="pi pi-exclamation-triangle"></span>
												<span>
													Assurez-vous d'avoir fait la saisie des heures ou KM pour cet équipement. ->
												</span>
												<button pButton pRipple icon="pi pi-pencil"
													class="mr-2 boutonGrille p-button-outlined" pTooltip="Faire la saisie des heures ou KM"
													(click)="surMenuContextuelAjustementHeureKm($event, item)"></button>
											</p>
										</ng-template>
									</p-messages>
								</td>
								<td *ngIf="!modeApercu">
									<button *ngIf="estAutorise('requisition_supprimer_item') && estModifiable"
										[disabled]="item.item.estLie" pButton pRipple icon="pi pi-trash"
										class="p-button-danger mr-2 boutonGrille"
										(click)="supprimerItems([item])"></button>
									<button pButton pRipple icon="pi pi-bars"
										class="p-button-secondary mr-2 boutonGrille"
										(click)="surMenuContextuelItem($event, item)"></button>

								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="9">
									<div class="flex flex-column justify-content-center align-items-center p-4">
										<i class="pi pi-info-circle" style="font-size: 2rem"></i>
										<span class="text-center">Aucun item.</span>
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>

				</p-tabPanel>
				<!-- TAB : ITEMS EN COMMANDE -->
				<p-tabPanel
					*ngIf="estAutorise('requisition_ajout_item') && requisition.type.typeRequisitionId == 1 && estModifiable && !modeApercu"
					[header]="'Items en commande (' + this.itemsCommande.length + ')'" leftIcon="pi pi-book">

					<p-table #dt [value]="itemsCommande" [columns]="selectedColumns" dataKey="itemCommandeId"
						autoLayout="true" [(selection)]="selectionMultipleItemCommande"
						(onRowSelect)="surChangementSelectionCommande()"
						(onRowUnselect)="surChangementSelectionCommande()"
						(onHeaderCheckboxToggle)="surChangementSelectionCommande()"
						styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" [filterDelay]="0"
						[globalFilterFields]="['item.numero','item.description','demandeur']">
						<ng-template pTemplate="caption">
							<div class="flex align-content-center justify-content-between">
								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text"
											(input)="dt.filterGlobal($event.target.value, 'contains')"
											placeholder="Recherche..." />
									</span>
								</div>
								<h5 class="titreTableau m-0">Items en commande</h5>
								<div>
									<!-- <p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="colonnesSelectionnees"
										optionLabel="header" selectedItemsLabel="{0} colonnes sélectionnés"
										[style]="{minWidth: '200px'}" placeholder="Colonnes..."></p-multiSelect> -->
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th style="min-width: 3rem">
									<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
								</th>
								<th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Qte
										<p-sortIcon field="quantite"></p-sortIcon>
										<p-columnFilter type="text" field="quantite" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<!-- <th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Qte <br> à venir
										<p-sortIcon field="quantiteDemande"></p-sortIcon>
										<p-columnFilter type="text" field="quantiteDemande" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th> -->
								<!-- <th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Qte <br> prêt
										<p-sortIcon field="quantiteDemande"></p-sortIcon>
										<p-columnFilter type="text" field="quantiteDemande" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th> -->
								<th pSortableColumn="numero">
									<div class="flex justify-content-between align-items-center">
										Numéro
										<p-sortIcon field="numero"></p-sortIcon>
										<p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="description">
									<div class="flex justify-content-between align-items-center">
										Description
										<p-sortIcon field="description"></p-sortIcon>
										<p-columnFilter type="text" field="description" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="statut.nom">
									<div class="flex justify-content-between align-items-center">
										Statut
										<p-sortIcon field="statut.nom"></p-sortIcon>
										<p-columnFilter field="statut" matchMode="in" display="menu"
											[showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
													(onChange)="filter($event.value)" optionLabel="name">
													<ng-template let-option pTemplate="item">
														<div class="multiselect-representative-option">

															<span class="ml-1">{{option.nom}}</span>
														</div>
													</ng-template>
												</p-multiSelect>
											</ng-template>
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="demandeur.prenom">
									<div class="flex justify-content-between align-items-center">
										Demandeur
										<p-sortIcon field="demandeur.prenom"></p-sortIcon>
										<p-columnFilter type="text" field="demandeur.prenom" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>

								<th style="min-width: 7rem; width: 7rem;"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item let-columns="columns">
							<tr>
								<td>
									<p-tableCheckbox [value]="item"></p-tableCheckbox>
								</td>
								<td>{{item.quantite}} / {{item.quantiteDemande}}</td>
								<td>{{item.item.numero}}</td>
								<td>{{item.item.description}}</td>
								<td><span [class]="'statut ' + item.statut.nom.replace(' ','').toLowerCase()">
										{{item.statut.nom}}
									</span>
								</td>
								<td><app-employe-avec-emplacement [employe]="item.demandeur"></app-employe-avec-emplacement></td>

								<td class="celluleTableau">
									<div class="flex">
										<button [disabled]="item.item.estLie" pButton pRipple icon="pi pi-check-square"
											class="p-button-success mr-2 boutonGrille"
											(click)="transfertItemCommande(item)"></button>
									</div>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="8">Aucun item.</td>
							</tr>
						</ng-template>
					</p-table>



				</p-tabPanel>
				<!-- TAB : ITEMS DISPONIBLES -->
				<p-tabPanel
					*ngIf="estAutorise('requisition_ajout_item') && (requisition.type.typeRequisitionId == 2 || requisition.type.typeRequisitionId == 3) && estModifiable && !modeApercu"
					[header]="'Items disponibles (' + (this.itemsDisponibles == null || !this.totalItemsDisponibles ? 'Chargement...' : this.totalItemsDisponibles) + ')'"
					leftIcon="pi pi-book">

					<p-table #dtItemsDisponibles [value]="itemsDisponibles" [columns]="selectedColumns" [lazy]="true"
						sort autoLayout="true" [(selection)]="selectionMultipleItemDisponible"
						[loading]="!itemsDisponiblesLoaded || totalItemsDisponibles === null"
						(onRowSelect)="surChangementSelectionDisponible()"
						(onRowUnselect)="surChangementSelectionDisponible()"
						(onHeaderCheckboxToggle)="surChangementSelectionDisponible()"
						(onLazyLoad)="onLazyLoadItemsDisponibles($event)"
						styleClass="p-datatable-sm p-datatable-striped" [rowHover]="true" [filterDelay]="0"
						[globalFilterFields]="['numero','description']" [rows]="50" [paginator]="true"
						[totalRecords]="totalItemsDisponibles" [rowsPerPageOptions]="[50, 100, 200, 300]">
						<ng-template pTemplate="caption">
							<div class="flex align-content-center justify-content-between">
								<div>
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text"
											(input)="dtItemsDisponibles.filterGlobal($event.target.value, 'contains')"
											placeholder="Recherche..." />
									</span>
								</div>
								<h5 class="titreTableau m-0">Items disponibles</h5>
								<div>
									<p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="colonnesSelectionnees"
										optionLabel="header" selectedItemsLabel="{0} colonnes sélectionnés"
										[style]="{minWidth: '200px'}" placeholder="Colonnes..."></p-multiSelect>
								</div>
							</div>
						</ng-template>
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th style="min-width: 3rem">
									<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
								</th>
								<th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Qte
										<p-sortIcon field="quantite"></p-sortIcon>
										<p-columnFilter type="numeric" field="quantite" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="numero">
									<div class="flex justify-content-between align-items-center">
										Numéro
										<p-sortIcon field="numero"></p-sortIcon>
										<p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="description">
									<div class="flex justify-content-between align-items-center">
										Description
										<p-sortIcon field="description"></p-sortIcon>
										<p-columnFilter type="text" field="description" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="statut.nom">
									<div class="flex justify-content-between align-items-center">
										Statut
										<p-sortIcon field="statut.nom"></p-sortIcon>
										<p-columnFilter field="statut.nom" matchMode="in" display="menu"
											[showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
													(onChange)="filter($event.value)">
													<ng-template let-option pTemplate="item">
														<div class="multiselect-representative-option">
															<span
																[class]="'ml-1 statut ' + option.replace(' ','').toLowerCase()">
																{{option}}
															</span>
														</div>
													</ng-template>
													<ng-template let-option pTemplate="selectedItem">
														<div class="multiselect-representative-option">
															<span
																[class]="'ml-1 statut ' + option.replace(' ','').toLowerCase()">
																{{option}}
															</span>
														</div>
													</ng-template>
												</p-multiSelect>
											</ng-template>
										</p-columnFilter>
									</div>
								</th>
								<th *ngFor="let col of columns">
									<div class="flex justify-content-between align-items-center">
										{{col.entete}}
									</div>
								</th>
								<th style="min-width: 7rem"></th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item let-columns="columns">
							<tr>
								<td>
									<p-tableCheckbox [value]="item"></p-tableCheckbox>
								</td>
								<td>{{item.quantite}}</td>
								<td>{{item.numero}}</td>
								<td>{{item.description}}</td>
								<td><span [class]="'statut ' + item.statut.nom.replace(' ','').toLowerCase()">
										{{item.statut.nom}}
									</span>
								</td>
								<td *ngFor="let col of columns">
									{{item[col.champ]}}
								</td>
								<td class="celluleTableau">
									<div class="flex">
										<button [disabled]="item.estLie" pButton pRipple icon="pi pi-check-square"
											class="p-button-success mr-2 boutonGrille"
											(click)="transfertItemDisponible(item)"></button>
									</div>
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7" class="text-center">
									<i class="pi pi-info-circle mr-2" style="font-size: 1.2rem"></i>
									Aucun item.
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="loadingicon">
							<tr>
								<td colspan="7">
									<p-progressSpinner></p-progressSpinner>
								</td>
							</tr>
						</ng-template>
					</p-table>



				</p-tabPanel>
				<p-tabPanel *ngIf="estAutorise('requisition_documents')" header="Documents" leftIcon="pi pi-file-pdf">
					<ng-template pTemplate="content">
						<app-document [typeLienDocument]="ETypeLienDocument.Requisition"
							[idLien]="requisition.requisitionId" [numero]="requisition.numero"
							[showFolders]="false"></app-document>
					</ng-template>
				</p-tabPanel>
			</p-tabView>
		</p-card>
	</div>


</div>